<section class="main">
    <div class=" supmain ">
        <h3>
            <span>
                <img src="assets/images/mangeunit/back.png">
            </span>
            {{villageName}}
        </h3>
    </div>
    <hr>

    <div>
        <h3>
            Units Village
        </h3>

        <section class="tableUnit table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">Unit name</th>
                        <th scope="col">Type</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of unitsarray">
                        <td style="cursor: pointer" (click)="unitDetails(item.name)">
                           {{item.name}}
                        </td>
                        <td>
                           <span>{{item.type.name}}</span> 
                        </td>
                    </tr>                    
                </tbody>
            </table>
        </section>

    </div>
</section>